<template>
  <div class="sm-image-list">
    <div class="img-list" >
      <div v-for="(src, i) in imgList">
        <img preview="0" :src="src" :key="i">
      </div>
    </div>
  </div>
</template>

<script>
import {imgList} from "../common/summitMeetingData";
export default {
  name: "SMImageList",
  data() {
    return {
      imgList
    }
  }
}
</script>

<style lang="less">
.mobile-home {
  .img-list {
    padding: 0 26px;
    display: flex;
    flex-wrap: wrap;
    >div {
      width: calc((100% - 15px) / 2);
      height: 130px;
      margin-bottom: 15px;
      &:nth-child(2n) {
        margin-left: 15px;
      }
      img {
        border-radius: 5px;
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>